<template>
  <BlFlexContainerMv padding="16px" align-items="center" justify-content="center" direction="column" class="h-[240px] text-center">
    <BlTextAv variation="body-16" class="qa-text-info">{{ info }}</BlTextAv>
    <BlButtonAv variation="secondary" class="mt-16 qa-button-reload" @click="onReload">Muat Ulang</BlButtonAv>
  </BlFlexContainerMv>
</template>

<script>
import {BlButtonAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaListWithIconShimmer',
  components: {
    BlButtonAv,
  },
  props: {
    info: {
      type: String,
      required: true,
    },
  },
  methods: {
    onReload() {
      this.$emit('reload');
    },
  },
};
</script>
